const { dom, svg } = require('../odo/odojs/')

module.exports = d =>
  dom('.page--normal', [
    dom('nav', [
      dom(
        'a.nav--logo',
        { attributes: { href: '/' } },
        svg('svg', {}, svg('use', { 'xlink:href': '/assets.svg#logo-horizontal' }))
      ),
      dom('ul', []),
      dom('ul.nav--right', [])
    ]),
    dom('hr'),
    dom('.page--content', d),
    dom('hr.secondary'),
    dom('footer', [
      dom('ul', [
        dom('li', { key: 1 }, dom('a', { attributes: { href: '/terms-of-use' } }, 'Terms of Use')),
        dom('li', { key: 2 }, dom('a', { attributes: { href: '/privacy-policy' } }, 'Privacy Policy')),
        dom('li', { key: 3 }, dom('a', { attributes: { href: '/contact' } }, 'Contact Us'))
      ])
    ])
  ])
